module.exports = __webpack_public_path__ + "img/Use_Your_Patterns_Graphic.98c36998.jpg";